import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Orb from './pages/Orb';
import Visualization1 from './pages/Visualization1';
import Visualization2 from './pages/Visualization2';
import GdpShare from './pages/GdpShare'
import Visualization4 from './pages/Visualization4';
import Visualization5 from './pages/Visualization5';
import CountryPage from './pages/CountryPage';
import NotFound from './pages/NotFound';
import Demo from './pages/Demo';
import Home from './Home';
import EarthMap from "./pages/EarthMapVis";

const RoutesComponent = () => {
    return (
        <Routes basename="/">
            <Route exact path="/travel-orb" element={<EarthMap />} />
            {/* <Route path="/orb" element={<Orb />} /> */}
            <Route path="/visualization1" element={<Visualization1 />} />
            <Route path="/visualization2" element={<Visualization2 />} />
            <Route path="/gdp-share" element={<GdpShare />} />
            <Route path="/visualization4" element={<Visualization4 />} />
            <Route path="/visualization5" element={<Visualization5 />} />
            <Route path="/travel-orb/:countryCode" element={<CountryPage />} />
            <Route path="/demo" element={<Demo />} />

            {/* <Route path="/earth" element={<EarthMap />} /> */}
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};

export default RoutesComponent;
